import React, { useState, useEffect } from 'react';
import { Form, Row, Col, Input, Tooltip } from 'antd';
import { insightMenuAcions } from '@model';
import { addHTTP } from '@utils/common';
import Action from '../../analysis/summary/Action';
import { StyleFormateTools } from '@components';
import {
  Editor,
  EditorState,
  RichUtils,
  convertToRaw,
  convertFromHTML,
  ContentState,
  SelectionState,
} from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import './dealRationale.scss';

const fromHTML = (str) => {
  const blocksFromHTML = convertFromHTML(str);
  const state = ContentState.createFromBlockArray(
    blocksFromHTML.contentBlocks,
    blocksFromHTML.entityMap,
  );
  return EditorState.createWithContent(state);
};
const toHTML = (state) => draftToHtml(convertToRaw(state.getCurrentContent()));
const DealItem = (props) => {
  const {
    label,
    edit,
    linkData,
    linkName,
    linkPlaceholder,
    name,
    type,
    info,
    showModal,
    form,
    tooltip,
    flag,
  } = props;
  const editorState = () => EditorState.createEmpty();
  // const isInternal = JSON.parse(window.localStorage.userInfo || '{}').isInternal;
  // const list = [insightMenuAcions.ADDINSIGHT, insightMenuAcions.VIEWINSIGHT];
  // const hasInsight = info?.hasInsight;
  // if (!hasInsight) {
  //   list.pop();
  // }
  // if (!isInternal) {
  //   list.shift();
  // }

  // const [check, setCheck] = useState();
  const [openedInsight, setOpenedInsight] = useState(undefined);
  const [editor, setEditor] = useState(() => editorState);
  // const handleChange = (e) => {
  //   setCheck(e.target.checked);
  // };

  const changeHandler = (name) => {
    const editorData = toHTML(editor);
    form.setFieldsValue({ [name]: editorData });
    return setEditor;
  };

  const editorStateHandler = (idx) => editor;
  const moveSelectionToEnd = (editorState) => {
    const content = editorState.getCurrentContent();
    const blockMap = content.getBlockMap();
    const key = blockMap.last().getKey();
    const length = blockMap.last().getLength();
    const selection = new SelectionState({
      anchorKey: key,
      anchorOffset: length,
      focusKey: key,
      focusOffset: length,
    });
    return EditorState.acceptSelection(editorState, selection);
  };

  useEffect(() => {
    if (type === 'textArea') {
      let str = info?.fieldValue || '';
      if (str.search(/ins>/) !== -1) {
        str = str.replace(/ins>/g, 'u>');
      }

      return setEditor(fromHTML(str));
    }
  }, [label, edit]);

  const getLabel = (label) => (
    <Row justify="space-between" className="dealRationale-label">
      <Col>
        <div className="dealRationale-label">
          {/*{info?.hasInsight && <i />}*/}

          {linkData && !edit ? (
            <div>
              <span className="dealRationale-label-name">{label}</span>
              <Tooltip
                title={
                  <a
                    href={addHTTP(linkData, 'http://')}
                    target="_Blank"
                    rel="noreferrer"
                    // style={{ text_decoration: 'underline' }}
                    className="tooltipLink"
                  >
                    {linkData}
                  </a>
                }
              >
                <div className="link-box">
                  <span className="appkiticon icon-link-outline a-font-12" />
                </div>
              </Tooltip>
            </div>
          ) : (
            <span className="dealRationale-label-name">{label}</span>
          )}
          {/*{!edit && linkName && list && list.filter(item => item).length > 0 && (*/}
          {/*  <Action*/}
          {/*    list={list}*/}
          {/*    // index={i}*/}
          {/*    activeIndex={openedInsight}*/}
          {/*    openFunc={list.length > 0 ? setOpenedInsight : () => {}}*/}
          {/*    // editRow={editRow(index)}*/}
          {/*    showModal={showModal}*/}
          {/*    category={label}*/}
          {/*  />*/}
          {/*)}*/}
        </div>
      </Col>
      <Col flex>
        {edit && linkName && (
          <Row>
            {/* <div>
              Source <Checkbox checked={check} onChange={handleChange} />
            </div> */}

            {/*<Action*/}
            {/*  list={list}*/}
            {/*  index={label}*/}
            {/*  activeIndex={openedInsight}*/}
            {/*  openFunc={list.length > 0 ? setOpenedInsight : () => {}}*/}
            {/*  // editRow={editRow(label)}*/}
            {/*  showModal={showModal}*/}
            {/*  category={label}*/}
            {/*/>*/}
          </Row>
        )}
      </Col>
    </Row>
  );

  return (
    <>
      {!edit && (
        <Form.Item
          name={name}
          className="form-right"
          label={getLabel(label)}

          // className={item.className}
          // initialValue={item.info?.fieldValue}
        >
          <div
            className="dealRationale-form-content"
            dangerouslySetInnerHTML={{
              __html: info?.fieldValue,
            }}
          />
        </Form.Item>
      )}
      {edit && type === 'text' && (
        <Tooltip
          trigger={['hover', 'click']}
          title={tooltip}
          placement="topLeft"
          overlayClassName={`${
            name === 'ourUnderstanding'
              ? 'dealRationale-tooltip-ourUnderstanding'
              : 'dealRationale-tooltip'
          }`}
        >
          <Form.Item
            name={name}
            //   label={label}
            label={getLabel(label)}
            initialValue={info?.fieldValue}
          >
            {!flag && type !== 'textArea' ? (
              <Input type="text" maxLength={60} />
            ) : (
              <Input.TextArea
                autoSize={{ minRows: 3, maxRows: 5 }}
                style={{ resize: 'none' }}
                maxLength={200}
              />
            )}
          </Form.Item>{' '}
        </Tooltip>
      )}
      {edit && type !== 'text' && (
        <Form.Item name={name} label={getLabel(label)}>
          <div>
            <Tooltip
              trigger={['hover', 'click']}
              title={tooltip}
              placement="topLeft"
              overlayClassName="dealRationale-tooltip"
            >
              {/*TODO: should be replaced by a generally used component, wudi want to fix text color issues, need about 2 days handle*/}
              <StyleFormateTools
                click={(type) => {
                  if (
                    type === 'unordered-list-item' ||
                    type === 'ordered-list-item'
                  ) {
                    setEditor(RichUtils.toggleBlockType(editor, type));
                  } else {
                    setEditor(RichUtils.toggleInlineStyle(editor, type));
                  }
                }}
              />
              <Editor
                editorState={editorStateHandler()}
                onChange={changeHandler(name)}
                onBlur={() => {
                  setEditor(moveSelectionToEnd(editor));
                }}
              />
            </Tooltip>
          </div>
        </Form.Item>
      )}

      {edit && linkName && (
        <Form.Item
          name={linkName}
          className="link-input"
          // className={item.className}
          initialValue={linkData}
        >
          <Input type="text" placeholder={linkPlaceholder} />
        </Form.Item>
      )}
    </>
  );
};

export default DealItem;
